import keyMirror from "keymirror"

export default keyMirror({
  ///Messagections
  GET_PLAN_LIST:null,
  GET_PLAN_DETAIL:null

})
